
import Coms from '@/communications'
import bus from '@/plugins/bus'

export default {
  async getCustomer ({ commit, state }, id) {
    try {
      const data = await Coms.customer.getCustomer(id)
      commit('setCustomerData', data)
      return data
    } catch (err) {
      console.error(err)
      bus.emit('notification', err.message || 'Failed to fetch customer.', {
        color: 'error',
        dark: true
      })
      throw err
    }
    },
  async checkForPowerPoints({ commit, state }) {
    if (state.id === null) {
      throw new Error('Unable To Comply: Customer Data Missing')
    }

    try {
      const data = await Coms.powerpoint.doesCustomerHavePowerPoints(state.id)
      commit('setPowerPoints', data)
      return data
    } catch (err) {
      console.error(err)
      bus.emit('notification', err, {
        color: 'error',
        dark: true
      })
      throw err
    }
  },
  async checkForReferenceFiles({ commit, state }) {
    if (state.id === null) {
      throw new Error('Unable To Comply: Customer Data Missing')
    }

    try {
      const data = await Coms.referenceFiles.doesCustomerHaveReferenceFiles(state.id)
      commit('setHasReferenceFiles', data)
      return data
    } catch (err) {
      console.error(err)
      bus.emit('notification', err, {
        color: 'error',
        dark: true
      })
      throw err
    }
  },
  async checkForFileSharing({ commit, state }) {
    if (state.id === null) {
      throw new Error('Unable To Comply: Customer Data Missing')
    }

    try {
      const data = await Coms.fileSharing.doesCustomerHaveFileSharingProjects(state.id)
      commit('setHasFileSharing', data)
      return data
    } catch (err) {
      console.error(err)
      bus.emit('notification', err, {
        color: 'error',
        dark: true
      })
      throw err
    }
  }
}
